import React, { useEffect, useState, useContext } from "react";
import { getBatches2 } from "../api";
import { useNavigate, Link } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import { deleteBatchConsolidado } from "../api"; // si no lo usas, puedes quitarlo

const BatchList5 = ({ id_c }) => {
  const { t } = useContext(LanguageContext);
  const [data, setData] = useState(null);

  const [filterBatch, setFilterBatch] = useState("");
  const [filterMachine, setFilterMachine] = useState("");
  const [filterProduct, setFilterProduct] = useState("");
  const [filterDateFrom, setFilterDateFrom] = useState("");
  const [filterDateTo, setFilterDateTo] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const result = await getBatches2(id_c);
      console.log("📦 Batches recibidos:", result);
      setData(result);
    };
    fetchData();
  }, [id_c]);

  if (!data) return <p>{t("MList1")}</p>;

  // --- Filtros (como ya los tenías) ---
  const filterBatchClean = filterBatch.trim().toLowerCase();
  const filterMachineClean = filterMachine.trim().toLowerCase();
  const filterProductClean = filterProduct.trim().toLowerCase();

  const filteredData = data.batches.filter((batch) => {
    const batchIdStr = batch.id_batch?.toString().toLowerCase() ?? "";
    const codMaqStr  = batch.cod_maq?.toLowerCase() ?? "";
    const idProdStr  = batch.id_prod?.toString().toLowerCase() ?? "";
    const batchDate  = batch.date_begin
      ? new Date(batch.date_begin).toISOString().split("T")[0]
      : "";

    if (filterDateFrom && batchDate < filterDateFrom) return false;
    if (filterDateTo   && batchDate > filterDateTo)   return false;

    return (
      batchIdStr.startsWith(filterBatchClean) &&
      codMaqStr.startsWith(filterMachineClean) &&
      idProdStr.startsWith(filterProductClean)
    );
  });

  // --- ✅ Deduplicar por (id_batch, cod_maq) y agrupar productos ---
  // Conserva el primer registro como "representativo" y acumula los id_prod únicos del grupo.
  const groupedMap = new Map();
  for (const row of filteredData) {
    const key = `${row.id_batch}::${row.cod_maq}`;
    const prodId = row.id_prod ?? "";

    if (!groupedMap.has(key)) {
      groupedMap.set(key, {
        ...row,
        all_products: new Set(), // acumularemos los id_prod únicos
      });
    }
    const entry = groupedMap.get(key);
    if (prodId !== "" && prodId !== null && prodId !== undefined) {
      entry.all_products.add(String(prodId));
    }
  }

  const uniqueByBatchMachine = Array.from(groupedMap.values()).map((e) => ({
    ...e,
    all_products: Array.from(e.all_products), // convierto Set -> Array para render
  }));

  // (Opcional) Ordenar: por id_batch desc y luego cod_maq asc
  uniqueByBatchMachine.sort((a, b) => {
    const aBatch = Number(a.id_batch) || 0;
    const bBatch = Number(b.id_batch) || 0;
    if (bBatch !== aBatch) return bBatch - aBatch; // desc
    return String(a.cod_maq).localeCompare(String(b.cod_maq));
  });

  console.log("🧪 Input actual:", filterProductClean);
  console.log("🔍 Total únicos por (lote,máquina):", uniqueByBatchMachine.length);

  return (
    <div className="box1">
      <div className="box9">
        <button className="button7" onClick={() => navigate("/new_batch")}>
          {t("batchList11")}
        </button>

        {/* Filtro de fechas */}
        <div style={{ clear: "both", width: "100%", display: "flex", justifyContent: "center", padding: "6px 0" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <span className="text3" style={{ whiteSpace: "nowrap" }}>{t("atr_dateFrom")}</span>
            <input
              type="date"
              value={filterDateFrom}
              onChange={(e) => setFilterDateFrom(e.target.value)}
            />
            <span className="text3" style={{ whiteSpace: "nowrap" }}>{t("atr_dateTo")}</span>
            <input
              type="date"
              value={filterDateTo}
              onChange={(e) => setFilterDateTo(e.target.value)}
            />
            {(filterDateFrom || filterDateTo) && (
              <button
                className="button8"
                onClick={() => { setFilterDateFrom(""); setFilterDateTo(""); }}
                style={{ whiteSpace: "nowrap", width: "auto" }}
              >
                ✕ {t("atr_all")}
              </button>
            )}
          </div>
        </div>

        {/* Inputs de búsqueda */}
        <div className="table5">
          <input
            type="text"
            placeholder="🔎 Filtrar por lote"
            value={filterBatch}
            onChange={(e) => setFilterBatch(e.target.value)}
            style={{ width: "30%", float: "left" }}
          />
          <input
            type="text"
            placeholder="🔎 Filtrar por máquina"
            value={filterMachine}
            onChange={(e) => setFilterMachine(e.target.value)}
            style={{ width: "30%", float: "left" }}
          />
          <input
            type="text"
            placeholder="🔎 Filtrar por producto"
            value={filterProduct}
            onChange={(e) => setFilterProduct(e.target.value)}
            style={{ width: "30%", float: "left" }}
          />
        </div>

        <table className="table5">
          <thead>
            <tr>
              <th>{t("batchList12")}</th>
              <th>{t("batchList2")}</th>
              <th>{t("batchList3")}</th>
              <th>{t("batchList13")}</th>
            </tr>
          </thead>
          <tbody>
            {uniqueByBatchMachine.map((batch, index) => {
              const products = batch.all_products || [];
              const productLabel =
                products.length === 0
                  ? (batch.id_prod ?? "")
                  : products.length === 1
                  ? products[0]
                  : `${products[0]} (+${products.length - 1})`;

              // al ir al detalle, usamos el primer id_prod (si existe)
              const prodToUse = products[0] ?? batch.id_prod ?? "";

              return (
                <tr key={`${batch.id_batch}-${batch.cod_maq}-${index}`}>
                  <td>{batch.id_batch}</td>
                  <td>{batch.cod_maq}</td>
                  <td>{productLabel}</td>
                  <td>
                    <button
                      className="button"
                      onClick={() => {
                        localStorage.setItem("selected_batch_id", batch.id_batch);
                        localStorage.setItem("selected_prod_id", prodToUse);
                        localStorage.setItem("selected_machine_code", batch.cod_maq);
                        navigate("/6.batchesDetail");
                      }}
                    >
                      {t("batchList13")}
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

      </div>
    </div>
  );
};

export default BatchList5;
